import React from 'react';
import { SdfAvatar, SdfBox } from '@synerg/react-components';
import { ContactUs } from './contactUs';

export const ContactsProject = (props = {}) => {
	const { contacts } = props;

	return (
		<div>
			<div className="text-heading-06 font-bold">ADP Marketplace Contacts</div>
				
			<div className="grid grid-flow-row-dense grid-cols-1 sm:grid-cols-3 md:grid-cols-3 gap-4 mt-6 overflow-auto max-h-3xl py-2">
				{contacts.map((item, index) => {
					const image = item.hasIcon ? `/self-service/api/contacts/${item.id}/image` : null;
					
					let initials = '';
					const nameFirst = item.name.split(' ').map(s => s[0]);

					if (nameFirst.length > 2) {
						initials = nameFirst.slice(0, 2).join('');
					} else {
						initials = nameFirst.slice(0, 1).join('');
					}

					return (
						<div key={index} className="flex flex-row col-span-1">
							<SdfBox
								data-cvs-id="3"
								id={item.name + index}
								variant="bordered"
								spacing="default"
								className="p-8 w-full"
							>
								{/* first section */}
								<div className='sm:block md:block lg:inline-flex xl:inline-flex'>
									<div className='pr-4 pb-4 text-center'>
										<SdfAvatar
											src={image}
											size={"lg"}
											shape={"circle"}
											initials={initials}
										/>
									</div>
									<div className="pb-4">
										<div className='text-heading-05 font-bold capitalize sm:text-center md:text-center lg:text-left xl:text-left'>
											{item.name}
										</div>
										<div className='text-heading-02 font-bold sm:text-center md:text-center lg:text-left xl:text-left'>
											{item.title}
										</div>
									</div>
								</div>
								{/* second section */}
								<ContactUs {...item} />
							</SdfBox>
						</div>
					);
				})}
			</div>
		</div>
	);
};
